<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M9.99381 3.66504L2.0625 19.886L4.5861 22.2598L19.0067 13.9515L9.99381 3.66504Z"
		fill={getTailwindColor(color)}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M9.00735 2.97712C9.15363 2.81584 9.39106 2.81553 9.53768 2.97644L19.9926 14.4498C20.1392 14.6108 20.1395 14.8719 19.9932 15.0332C19.8469 15.1944 19.6095 15.1948 19.4629 15.0339L9.00797 3.56048C8.86136 3.39957 8.86108 3.1384 9.00735 2.97712Z"
		fill={getTailwindColor(color)}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M1.69376 19.3804C1.82338 19.2071 2.06 19.1861 2.22223 19.3333L5.1361 21.7615C5.29833 21.9087 5.32476 22.1684 5.19513 22.3417C5.06551 22.5149 4.82889 22.536 4.66665 22.3888L1.75279 19.9606C1.59056 19.8134 1.56413 19.5537 1.69376 19.3804Z"
		fill={getTailwindColor(color)}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M9.9945 21.4342C11.3739 21.4342 12.4891 20.2075 12.4891 18.6984C12.4891 17.1894 11.3739 15.9627 9.9945 15.9627C8.6151 15.9627 7.49988 17.1894 7.49988 18.6984C7.49988 20.2075 8.6151 21.4342 9.9945 21.4342ZM9.9945 22.2592C11.7865 22.2592 13.2391 20.665 13.2391 18.6984C13.2391 16.7319 11.7865 15.1377 9.9945 15.1377C8.20255 15.1377 6.74988 16.7319 6.74988 18.6984C6.74988 20.665 8.20255 22.2592 9.9945 22.2592Z"
		fill={getTailwindColor(color)}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M17.7234 5.91876C16.797 5.03699 15.7428 5.05706 15.0633 5.12468C14.9258 5.13837 14.8042 5.02684 14.7918 4.87558C14.7794 4.72432 14.8807 4.5906 15.0183 4.57692C15.7303 4.50604 16.9635 4.46817 18.0505 5.50285C18.4886 5.91982 18.6801 6.47208 18.7727 6.99373C18.8368 7.35468 18.857 7.73325 18.8738 8.04598C18.8805 8.17202 18.8867 8.28739 18.8949 8.38659C18.9074 8.53784 18.8062 8.67164 18.6687 8.68546C18.5312 8.69928 18.4095 8.58786 18.397 8.43661C18.386 8.30507 18.3789 8.17036 18.3717 8.03272C18.3559 7.73461 18.3394 7.4227 18.282 7.09917C18.2007 6.64145 18.0443 6.2242 17.7234 5.91876Z"
		fill={getTailwindColor(color)}
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M20.0313 3.36865C18.3962 1.57432 15.9264 1.56336 14.271 2.47192C14.1474 2.53972 13.9973 2.48452 13.9357 2.34862C13.874 2.21271 13.9242 2.04757 14.0477 1.97977C15.8485 0.991464 18.5632 0.980629 20.3844 2.97928C21.2904 3.97348 21.8301 5.28859 22.0986 6.54777C22.3664 7.80418 22.3706 9.03514 22.1785 9.87854C22.1449 10.0259 22.0091 10.1154 21.8752 10.0784C21.7413 10.0415 21.6599 9.89218 21.6935 9.74485C21.8619 9.00571 21.8661 7.86605 21.6118 6.67336C21.3581 5.48344 20.8535 4.27094 20.0313 3.36865Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
